export default "__VITE_ASSET__BML$pgld__"